<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h4 class="panel-title">
        <a class="accordion-toggle" data-toggle="collapse" v-bind:href="randomGateHref(item.userId)" aria-expanded="true" @click="getData(item.userId)">
          <i class="bigger-110 ace-icon fa fa-angle-right" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
          &nbsp;期限付きゲート
        </a>
      </h4>
    </div>
    <div class="panel-collapse collapse" :id="randomGateClass(item.userId)" aria-expanded="true">
      <div class="panel-body">
        <table style="min-width:100%" class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <th >ゲートID</th>
              <th>ゲート名</th>
              <th class="center">開始日時</th>
              <th class="center">終了日時</th>
            </tr>
          </thead>
          <tbody v-if="listGatePassages!=null">
            <template v-for="(item, index) in listGatePassages">
              <tr :key="index" v-if="item.gateId.isValid">
                <td><a class="link" @click="viewGate(item.gateId.gateId)">{{item.gateId.gateId}}</a></td>
                <td>{{item.gateId.gateName}}</td>
                <td class="center">{{converDate(item.notBefore)}}</td>
                <td class="center">{{converDate(item.notAfter)}}</td>
              </tr>
            </template>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4">データーはありません</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'

export default {
  props: ['item'],
  data () {
    return {
      listGatePassages: null,
      currentTime: ''
    }
  },
  mounted () {
    var vm = this
    vm.currentTime = vm.converTimestamp(Date())
  },
  methods: {
    getData (userId) {
      this.listGatePassages = null
      this.getInforGatePassage(userId)
    },
    // ゲート取得
    getInforGate (gateId, i) {
      var vm = this
      this.$http.get(Config.GATES_LIST_API + '?gateId=' + encodeURIComponent(gateId) + '&isValid=true')
        .then(response => {
          vm.listGatePassages[i].gateId = response.body.gates[0]
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 期限付きゲート
    getInforGatePassage (userId) {
      var vm = this
      this.$http.get(Config.GATES_PASSAGE_API + '?userId=' + encodeURIComponent(userId) + '&notBefore=' + vm.currentTime)
        .then(response => {
          if (response.body.maxRecords > 0) {
            vm.listGatePassages = response.body.passages
            for (var i = 0; i < vm.listGatePassages.length; i++) {
              vm.getInforGate(vm.listGatePassages[i].gateId, i)
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    converTimestamp (t) {
      return parseInt(new Date(t) / 1000)
    },
    viewGate (id) {
      let routeData = this.$router.resolve({name: 'gateedit', query: {id: id}})
      window.open(routeData.href, '_blank')
    },
    removeSpecialSymboy (text) {
      return text.replace(/[^a-z0-9\s]/gi, '-').replace(/[_\s]/g, '-')
    },
    randomGateClass (classname) {
      return 'gate' + this.removeSpecialSymboy(classname)
    },
    randomGateHref (classname) {
      return '#gate' + this.removeSpecialSymboy(classname)
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/UserDetailGate.vue